/**
 * Scroll Utilities
 * Helper functions for smooth scrolling behavior
 */

/**
 * Smoothly scroll to the bottom of the page
 * @param delay - Optional delay in milliseconds before scrolling (default: 300ms)
 */
export const scrollToBottom = (delay = 300): void => {
  setTimeout(() => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth',
    });
  }, delay);
};

/**
 * Smoothly scroll to a specific element
 * @param elementId - ID of the element to scroll to
 * @param delay - Optional delay in milliseconds before scrolling (default: 300ms)
 */
export const scrollToElement = (elementId: string, delay = 300): void => {
  setTimeout(() => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, delay);
};

/**
 * Scroll to top of the page
 */
export const scrollToTop = (): void => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};
